import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    authenticateUser,
    authenticatedUser,
    failedAuthenticateUser
} from "actions";
import uuid from "uuid/v4";
import { Map } from "immutable";
import { Alert, Icon } from "antd";
import { Layout, Row, Col, message, Button } from "antd";
import { AuthForm, ForgotNewPasswordForm, ForgotPasswordEmailForm } from "forms";
import { AuthService } from "services";
import { XHR_ERRORS } from "constants";
import PROGCAP_ICON from "assets/progcapLogo.png";


class AuthView extends React.Component {
    formID = uuid();
    state = {
        formSubmitting: false,
        authError: null,
        values: null,
        invalidCredentialsErrorVisible: false,
        showForgotPasswordForm: false,
        passwordEntryForm: false,
        emailEntryForm: false,
        showBankMessage: false,
        userEmail: null,
        password: null
    };
    componentWillMount() {
        if (AuthService.isAuthenticated()) {
            this.props.history.replace("/app");
        }
    }
    authenticate = values => {
        this.props.authenticateUser();
        this.setState(
            {
                formSubmitting: true,
                authError: null,
                values: new Map(values)
            },
            () =>
                AuthService.authenticate(values.username, values.password, values.recaptchaToken, values.microsoftAuthResponse).then(
                    ({ error }) => {
                        if (error) {
                            this.props.failedAuthenticateUser();
                            switch (error) {
                                case XHR_ERRORS.NETWORK_ERROR:
                                    message.warning("No Internet Access", 5);
                                    return;
                                case XHR_ERRORS.SERVICE_DOWN:
                                    message.warning(
                                        "Please try again after sometime."
                                    );
                                    return;
                                case XHR_ERRORS.INVALID_CREDENTIALS:
                                    setTimeout(() => this.setState({
                                        authError: "It seems you entered an incorrect password",
                                        invalidCredentialsErrorVisible: true,
                                        formSubmitting: false
                                    }), 1000);
                                    return;
                                default:
                                    return;
                            }
                        } else {
                            this.props.history.replace("/app");
                        }
                    }
                ).catch((err) => {
                    const { error, attemps_left } = err;
                    if (error == "Access Denied, Redirecting to onboarding portal.") {
                        this.redirectToOnboarding();
                    }
                    else if (error == "invalid_grant") {
                        if (attemps_left !== null && attemps_left !== undefined) {
                            setTimeout(() => this.setState({
                                formSubmitting: false,
                                authError: (
                                    <div>
                                        <span>It seems you entered an incorrect password</span><br />
                                        <span>{attemps_left || 0} Attempts Left</span>
                                    </div>
                                ),
                                invalidCredentialsErrorVisible: true
                            }), 2000);

                        } else {
                            setTimeout(() => this.setState({
                                formSubmitting: false,
                                authError: (
                                    <div>
                                        <span>User not found or inactive. Please contact administrator.</span>
                                    </div>
                                ),
                                invalidCredentialsErrorVisible: true
                            }), 2000);
                        }

                    }
                    if(error && error[0] == "missing-input-response") {
                        setTimeout(() => this.setState({
                            formSubmitting: false,
                            authError: <div><span>It seems you are trying to login with wrong Credentials</span><br /><span>{attemps_left || 0} Attempts Left</span></div>,
                            invalidCredentialsErrorVisible: true
                        }), 2000);
                    } else if(error == "You are lockedout.Please try after some time.") {
                        setTimeout(() => this.setState({
                            formSubmitting: false,
                            authError: "Due to multiple login attempts failure,You are lockedout from the system, Please try after 15 Minutes",
                            invalidCredentialsErrorVisible: true
                        }), 2000);
                    }else {
                        setTimeout(() => this.setState({
                            formSubmitting: false,
                            authError: <div><span>It seems you entered an incorrect password</span><br /><span>{attemps_left || 0} Attempts Left</span></div>,
                            invalidCredentialsErrorVisible: true
                        }), 2000);
                    }
                })
        );
    };


    openForgotPasswordWindow = () => {
        this.setState({
            showForgotPasswordForm: true,
            emailEntryForm: true
        });
    }

    renderAlert() {
        if (this.state.invalidCredentialsErrorVisible) {
            return (
                <Alert
                    message="Invalid Credentials"
                    type="warning"
                    closable
                    onClose={() =>
                        this.setState({ invalidCredentialsErrorVisible: false })
                    }
                />
            );
        }
        return null;
    }

    showEmailEntryForm = () => {
        this.setState({
            emailEntryForm: true
        });
    }

    sendOtp = (values) => {
        AuthService.sendOtp(values.email).then(() => {
            this.setState({
                emailEntryForm: false,
                username: values.email,
                passwordEntryForm: true
            });
            message.success("OTP sent successfully");
        }).catch((err) => {
            // interceptor already unwraps response.data into err
            if(err?.status >= 500) return; // already handled by interceptor
            const errorMsg = err?.error || err?.message || err?.detail || (typeof err === "string" ? err : "Failed to send OTP. Please check your email.");
            message.error(errorMsg);
        });
    }

    changePassword = (values) => {
        AuthService.changePassword({...values, email: this.state.username}).then(({data, error}) => {
            if(data) {
                message.success("Password Changed Successfully");
                this.setState({
                    passwordEntryForm: false,
                    showForgotPasswordForm: false
                });
            } else if(error) {
                message.error("Failed to change Password");
            }
        }).catch((err) => {
            // interceptor already unwraps response.data into err
            if(err?.status >= 500) return; // already handled by interceptor
            if(err?.new_password?.length) {
                err.new_password.forEach(msg => message.error(msg));
                return;
            }
            const errorMsg = err?.non_field_errors?.[0] || err?.error || err?.message || err?.detail || (typeof err === "string" ? err : "Failed to change Password");
            message.error(errorMsg);
        });
    }

    redirectToLosDesk = (userEmail) => {
        message.loading({ content: "Redirecting to LOS Desk", key: "updatable" });
        setTimeout(() => {
            window.location.replace(`https://los-desk.progcap.com?username=${userEmail}`, {
                username: this.state.userEmail,
                password: this.state.password
            });    
        }, 5000);
        
    }

    redirectToOnboarding = (userEmail) => {
        message.loading({ content: "Redirecting to Onboarding Portal", key: "updatable" });
        setTimeout(() => {
            window.location.replace(`https://onboarding.progcap.com?username=${userEmail}`, {
                username: this.state.userEmail,
                password: this.state.password
            });
        }, 5000);
    }

    renderBrandPanel() {
        return (
            <div className="login-brand-panel">
                <img src={PROGCAP_ICON} alt="logo" className="brand-logo" />
                <p className="brand-tagline">Empowering Supply Chain Finance</p>
                <p className="brand-desc">A unified platform to manage lending operations, track applications, and drive faster decisions.</p>
                <div className="brand-features">
                    <div className="brand-feature-item"><div className="brand-feature-dot" />End-to-end loan origination system</div>
                    <div className="brand-feature-item"><div className="brand-feature-dot" />Real-time application tracking</div>
                    <div className="brand-feature-item"><div className="brand-feature-dot" />Secure, role-based access control</div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <React.Fragment>
                {!this.state.showForgotPasswordForm && !this.state.emailEntryForm && !this.state.passwordEntryForm ?
                    <div className="login-page">
                        {this.renderBrandPanel()}

                        <div className="login-right-panel">
                            <div className="login-container">
                                <div className="login-card">
                                    <img src={PROGCAP_ICON} alt="logo" className="logo" />
                                    <p className="subtitle">Welcome back</p>
                                    <p className="desc">Please sign in to continue</p>
                                    <AuthForm
                                        id={this.formID}
                                        submitValues={this.authenticate}
                                        formSubmitting={this.state.formSubmitting}
                                        values={this.state.values}
                                        askBankUser={this.redirectToLosDesk}
                                        onForgotPassword={this.openForgotPasswordWindow}
                                    />
                                    {this.state.authError ?
                                        <p className={"mb-0 d-flex align-items-center"} style={{ color: "red", fontSize: "13px", marginTop: "12px" }}>
                                            <Icon type={"exclamation-circle"} className={"mr-5"} color={"red"} />{" "}
                                            {this.state.authError}
                                        </p> : null
                                    }
                                    <p className="login-footer">By signing in, you agree to our Terms of Service &amp; Privacy Policy</p>
                                </div>
                            </div>
                            <p className="login-page-footer">&copy; {new Date().getFullYear()} Progcap. All rights reserved.</p>
                        </div>
                    </div>
                    : this.state.showForgotPasswordForm && this.state.emailEntryForm && !this.state.passwordEntryForm ? (
                        <div className="login-page">
                            {this.renderBrandPanel()}
                            <div className="login-right-panel">
                                <div className="login-container">
                                    <div className="login-card">
                                        <div className="forgot-password-icon">
                                            <Icon type="lock" />
                                        </div>
                                        <p className="subtitle">Forgot Password?</p>
                                        <p className="desc">Enter your registered email and we'll send you an OTP to reset your password.</p>
                                        <ForgotPasswordEmailForm submitValues={this.sendOtp} />
                                        <Button
                                            type="link"
                                            onClick={() => this.setState({ showForgotPasswordForm: false, emailEntryForm: false })}
                                            style={{ marginTop: "8px", fontSize: "13px" }}
                                        >
                                            ← Back to Login
                                        </Button>
                                    </div>
                                </div>
                                <p className="login-page-footer">&copy; {new Date().getFullYear()} Progcap. All rights reserved.</p>
                            </div>
                        </div>
                    ): (
                        <div className="login-page">
                            {this.renderBrandPanel()}
                            <div className="login-right-panel">
                                <div className="login-container">
                                    <div className="login-card">
                                        <div className="forgot-password-icon">
                                            <Icon type="key" />
                                        </div>
                                        <p className="subtitle">Set New Password</p>
                                        <p className="desc">Enter the OTP sent to your email and choose a new password.</p>
                                        <ForgotNewPasswordForm submitValues={this.changePassword} />
                                        <Button
                                            type="link"
                                            onClick={() => this.setState({ showForgotPasswordForm: false, emailEntryForm: false, passwordEntryForm: false })}
                                            style={{ marginTop: "8px", fontSize: "13px" }}
                                        >
                                            ← Back to Login
                                        </Button>
                                    </div>
                                </div>
                                <p className="login-page-footer">&copy; {new Date().getFullYear()} Progcap. All rights reserved.</p>
                            </div>
                        </div>
                    )}
                {this.renderAlert()}
            </React.Fragment>
        );
    }
}

AuthView.propTypes = {
    location: PropTypes.object,
    match: PropTypes.object,
    history: PropTypes.object,
    authenticateUser: PropTypes.func,
    failedAuthenticateUser: PropTypes.func
};

const mapStateToProps = state => {
    return { auth: state.auth };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            authenticateUser,
            authenticatedUser,
            failedAuthenticateUser
        },
        dispatch
    );
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AuthView);
